<template>
    <svg :width="size" :height="size" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1664_8773)">
    <rect :width="size" :height="size" rx="3" fill="white"/>
    <path d="M0 3.438C0 1.539 1.578 0 3.525 0H44.475C46.422 0 48 1.539 48 3.438V44.562C48 46.461 46.422 48 44.475 48H3.525C1.578 48 0 46.461 0 44.562V3.438ZM14.829 40.182V18.507H7.626V40.182H14.829ZM11.229 15.546C13.74 15.546 15.303 13.884 15.303 11.802C15.258 9.675 13.743 8.058 11.277 8.058C8.811 8.058 7.2 9.678 7.2 11.802C7.2 13.884 8.763 15.546 11.181 15.546H11.229ZM25.953 40.182V28.077C25.953 27.429 26.001 26.781 26.193 26.319C26.712 25.026 27.897 23.685 29.889 23.685C32.496 23.685 33.537 25.671 33.537 28.587V40.182H40.74V27.75C40.74 21.09 37.188 17.994 32.448 17.994C28.626 17.994 26.913 20.094 25.953 21.573V21.648H25.905C25.9209 21.623 25.9369 21.598 25.953 21.573V18.507H18.753C18.843 20.541 18.753 40.182 18.753 40.182H25.953Z" fill="#0A66C2"/>
    </g>
    <defs>
    <clipPath id="clip0_1664_8773">
    <rect :width="size" :height="size" rx="3" fill="white"/>
    </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    size: { type: String }
  }
}
</script>